import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import { IncidentLightDto } from '@/api';
import i18n from '@/i18n';
import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';

interface StatusProps {
  status: IncidentLightDto.status,
  qualification?: IncidentLightDto.qualification | null
  dense?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Incident-Status',
  props: {
  status: null,
  qualification: null,
  dense: { type: Boolean }
},
  setup(__props) {

const props = __props;


const status = _computed(() => {
  switch (props.status) {
    case IncidentLightDto.status.OPEN:
      return {
        text: i18n.t('incidents.statuses.OPEN'),
        color: 'borderAttention',
        icon: 'icon-arrow-up-circle-fill',
        iconColor: 'iconAttention',
      };
    case IncidentLightDto.status.IN_PROGRESS:
      return {
        text: i18n.t('incidents.statuses.IN_PROGRESS'),
        color: 'borderAccent',
        icon: 'icon-arrow-right-circle-fill',
        iconColor: 'iconInfo',
      };
    case IncidentLightDto.status.CLOSED:
      return {
        text: i18n.t('incidents.statuses.CLOSED') + (props.qualification ? ` • ${i18n.t(`incidents.qualifications.${props.qualification}`)}` : ''),
        color: 'borderPrimary',
        icon: 'icon-check-circle-fill',
        iconColor: 'iconNeutral',
      };
    default:
      return {
        text: '',
        color: 'grey',
        icon: '',
        iconColor: '',
      };
  }
});
const iconSize = _computed(() => (props.dense ? 'x-small' : 'small'));

return { __sfc: true,props, status, iconSize, _computed, IncidentLightDto, i18n, SEllipsisTooltip }
}

})